import {
  I18N_STORAGE_KEY,
  LANGUAGES,
  translations,
  type Language
} from './translations';

export const isSupportedLanguage = (value: string): value is Language =>
  LANGUAGES.includes(value as Language);

export const normalizeLanguage = (value?: string | null): Language => {
  const normalizedValue = value?.toLowerCase().split('-')[0];

  if (normalizedValue && isSupportedLanguage(normalizedValue)) {
    return normalizedValue;
  }

  return 'en';
};

export const getInitialLanguage = (): Language => {
  if (typeof window === 'undefined') {
    return 'en';
  }

  const storedLanguage = window.localStorage.getItem(I18N_STORAGE_KEY);

  if (storedLanguage && isSupportedLanguage(storedLanguage)) {
    return storedLanguage;
  }

  return normalizeLanguage(window.navigator.language);
};

export const getCurrentTranslation = () => translations[getInitialLanguage()];
